import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, Shield, RefreshCw } from 'lucide-react';
import Sidebar from './Sidebar';
import { useQueryClient } from '@tanstack/react-query';

export const AdminLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const queryClient = useQueryClient();

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await queryClient.invalidateQueries({ queryKey: ['admin'] });
    setTimeout(() => setIsRefreshing(false), 1000);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-secondary-900">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        variant="admin"
      />

      {/* Main content */}
      <div className="lg:ml-64 min-h-screen flex flex-col">
        {/* Top header */}
        <header className="bg-white dark:bg-secondary-800 border-b border-gray-200 dark:border-secondary-700 sticky top-0 z-30">
          <div className="flex items-center justify-between px-4 py-3">
            {/* Mobile menu button */}
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-secondary-700"
              aria-label="Abrir menu"
            >
              <Menu className="w-6 h-6 text-gray-500 dark:text-gray-400" />
            </button>

            {/* Title */}
            <div className="flex items-center gap-2">
              <Shield className="w-5 h-5 text-red-500" />
              <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                Admin Panel
              </h1>
            </div>

            {/* Right side actions */}
            <div className="flex items-center gap-2">
              {/* Refresh button */}
              <button
                onClick={handleRefresh}
                disabled={isRefreshing}
                className="flex items-center gap-2 px-3 py-2 rounded-lg
                  text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-secondary-700
                  disabled:opacity-50 transition-colors duration-200"
                aria-label="Atualizar dados"
              >
                <RefreshCw
                  className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`}
                />
                <span className="hidden sm:inline text-sm font-medium">
                  Atualizar
                </span>
              </button>

              {/* Admin indicator */}
              <div className="flex items-center gap-2 pl-3 border-l border-gray-200 dark:border-secondary-700">
                <div className="w-9 h-9 bg-red-100 dark:bg-red-900/50 rounded-full flex items-center justify-center">
                  <Shield className="w-5 h-5 text-red-600 dark:text-red-400" />
                </div>
              </div>
            </div>
          </div>

          {/* Warning banner */}
          <div className="bg-red-50 dark:bg-red-900/20 border-t border-red-100 dark:border-red-900/30 px-4 py-2">
            <p className="text-xs text-red-600 dark:text-red-400 text-center">
              Voce esta no painel administrativo. Todas as acoes sao registradas.
            </p>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>

        {/* Footer */}
        <footer className="border-t border-gray-200 dark:border-secondary-700 py-4 px-6">
          <p className="text-center text-sm text-gray-500 dark:text-gray-400">
            KeepNota Admin Panel - Acesso Restrito
          </p>
        </footer>
      </div>
    </div>
  );
};

export default AdminLayout;
